<template>
  <div>

    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex  justify-space-between">
        <v-col cols="12" sm="12" md="5" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/maquinado">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Editar Maquinado</h1>
        </v-col>
        <v-col cols="12" sm="12" md="3" class="my-auto">
          <span class="mt-2 text-h4 ml-auto">
            {{ mostrarFolio }}
          </span>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mt-3 mx-1" :loading="cargando" :disabled="estatus == 'T' || estatus == 'B'" >
      <v-card-title>
        <h4>Informacion:</h4>
        <v-btn class="mt-2 ml-auto primary mx-1" small text @click="terminarMaquinado">Pieza Terminada</v-btn>
      </v-card-title>

      <v-divider ></v-divider>

      <v-card-title class="py-0">
        <!-- SECCION FECHA1 -->
        <v-menu v-model="modalFecha1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
        offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
        <v-text-field v-model="fechaSalida" label="Fecha salida" prepend-icon="mdi-calendar"
        light readonly v-bind="attrs" v-on="on" class="mx-3"/>
        </template>
        <v-date-picker v-model="fechaSalida" @input="modalFecha1 = false" :min="minFecha[0]"/>
        </v-menu>
        <!-- FIN SECCION FECHA1 -->

        <!-- SECCION FECHA2 -->
        <v-menu v-model="modalFecha2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
        offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }" >
            <v-text-field v-if="fechaEntrada != ''" v-model="fechaEntrada" label="Fecha entrada" prepend-icon="mdi-calendar"
            light readonly v-bind="attrs" v-on="on" class="mx-1"/>
            <v-text-field v-else v-model="mensajeFecha" label="Fecha entrada" prepend-icon="mdi-calendar"
            light readonly class="mx-1" v-bind="attrs" v-on="on" :rules="reglasFecha"/>
          </template>
          <v-date-picker v-model="fechaEntrada" @input="modalFecha2 = false" />
        </v-menu>
        <!-- FIN SECCION FECHA -->

        <!-- </div> -->
        <!-- {{`Entrada: ${fechaEntrada},  Salida: ${fechaSalida}`}} -->
      </v-card-title>

      <div class="mx-3">
        <v-row class="d-flex">
          <v-col cols="12" sm="12" md="6">
            <v-autocomplete class="mx-1" label="Almacen Salida" v-model="almacenSalida" :items="almacenes" item-text="NOMBRE" item-value="ALMACEN_ID" />
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-autocomplete class="mx-1" label="Almacen Entrada" v-model="almacenEntrada" :items="almacenes" item-text="NOMBRE" item-value="ALMACEN_ID"
            :rules="reglas"/>
          </v-col>
        </v-row>
        <v-autocomplete class="mx-1" label="Asignar Proyecto" v-model="proyectoSeleccionado" :items="proyectos" :item-text="getTexto" item-value="PROYECTO_ID" itemid="PROYECTO_ID"/>

        <v-row>
          <v-col cols="12" sm="12" md="6" class="">
            <v-data-table :headers="colsSalida" :items="articulosSalida" class="tamTexto">
              <template v-slot:header="{props:{headers} }">
                <thead>
                  <tr>
                    <th :colspan="headers.length">
                      Articulo/s de Salida
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.CANTIDAD`]="{ item }">
                <v-text-field
                  v-model="item.CANTIDAD"
                  label="Cantidad"
                  type="number"
                  min="1"
                  hide-details
                  dense
                  single-line
                  @input="getTotal"
                />
              </template>

              <template v-slot:[`item.PRECIO_UNITARIO`]="{ item }">
                <v-text-field
                  v-model="item.PRECIO_UNITARIO"
                  label=""
                  type="number"
                  min="0"
                  dense
                  step=".5"
                  hide-details
                  single-line
                  prefix="$"
                  @input="calcularTotales(item)"
                />
              </template>

            </v-data-table>        
          </v-col>

          <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>

          <v-col cols="12" sm="12" md="6">
            <v-data-table :headers="colsEntrada" :items="articulosEntrada" class="tamTexto">
              <template v-slot:header="{props:{headers} }">
                <thead>
                  <tr>
                    <th :colspan="headers.length">
                      Producto/s de Entrada
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.CANTIDAD`]="{ item }">
                <v-text-field
                  v-model="item.CANTIDAD"
                  label="Cantidad"
                  type="number"
                  min="1"
                  hide-details
                  dense
                  single-line
                  @input="getTotal"
                />
              </template>              

              <template v-slot:[`item.PRECIO_UNITARIO`]="{ item }">
                <v-text-field
                  v-model="item.PRECIO_UNITARIO"
                  label=""
                  type="number"
                  min="0"
                  dense
                  step=".5"
                  hide-details
                  single-line
                  prefix="$"
                  @input="calcularTotales(item)"
                />
              </template>

            </v-data-table>        

          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-space-around">
        <v-btn small class="grey darken-2" dark to="/maquinado"> Cancelar</v-btn>
        <v-btn small class="primary darken-2" dark @click="guardarCambios"> Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      //DATOS PARA EDITAR
      maquinado_id:  0,
      fechaSalida:   '',
      fechaEntrada:  '',
      almacenSalida: null,
      almacenEntrada:null,
      proyectoSeleccionado:0,

      //DATOS PARA VALIDACION
      articulos:[],
      reglas:[],
      reglasFecha:[],

      cargando:     false,
      infoMaquinado:null,
      estatus:'',
      minFecha:'',
      mensajeFecha:'',
      modalFecha1:  false,
      modalFecha2:  false,
      almacenes:[],
      proyectos:[],
      colsSalida:[
        {text:"Nombre", value:'NOMBRE'},
        {text:"Cantidad", value:'CANTIDAD', width:'8%', sortable:false,},
        {text:"Precio", value:'PRECIO_UNITARIO', sortable:false, width:'20%'},
      ],
      colsEntrada:[
        {text:"Nombre", value:'NOMBRE'},
        {text:"Cantidad", value:'CANTIDAD', sortable:false, width:'8%'},
        {text:"Precio", value:'PRECIO_UNITARIO', sortable:false, width:'20%'},
      ],
    }
  },

  // ------------------------------------------------------------------------------
  computed: {
    ...mapGetters(['getURLAPI','getUsuario','getFechaActual']),

    // ------------------------------------------------------------------------------
    mostrarFolio : function () {
      if (this.infoMaquinado && this.infoMaquinado.FOLIO) {
        return this.infoMaquinado.FOLIO
      }
      else{
        return ''
      }
    },

    // ------------------------------------------------------------------------------
    articulosSalida:function(){
      return this.articulos.filter( (articulo) =>{
        return articulo.TIPO.toUpperCase().match("S");
      } )
    },

    // ------------------------------------------------------------------------------
    articulosEntrada:function(){
      return this.articulos.filter( (articulo) =>{
        return articulo.TIPO.toUpperCase().match("E");
      } )
    },


  },

  // ------------------------------------------------------------------------------
  methods:{

    // ------------------------------------------------------------------------------
    getDetalle(){
      this.infoMaquinado = null;
      this.estatus = '';
      this.fechaSalida = null;
      this.fechaEntrada = null;
      this.almacenSalida = null;
      this.almacenEntrada = null;
      this.proyectoSeleccionado = null;
      this.articulos = [];

      this.cargando = true;
      let datosForm = new FormData();
      datosForm.append("MAQUINADO_ID",this.maquinado_id )
      axios.post(`${this.getURLAPI}/Maquinado/mostrarDetalle`, datosForm)
      .then( ({data}) =>{
        console.log(data);
        this.infoMaquinado= data[0];
        this.estatus = data[0].ESTATUS;
        this.fechaSalida  = data[0].FECHA_SALIDA;
        this.fechaEntrada = data[0].FECHA_ENTRADA ?? '';
        this.mensajeFecha = 'Fecha no definida'
        this.almacenSalida= data[0].ALMACEN_ID;
        this.almacenEntrada=data[0].ALMACEN_DESTINO_ID ?? 0;
        this.proyectoSeleccionado = data[0].PROYECTO_ID;
        this.articulos = data;
        
      })
      this.cargando = false;

    },

    // ------------------------------------------------------------------------------
    async getAlmacenes(){
      this.almacenes = (await axios.get(`${this.getURLAPI}/Show/allStorage`)).data;
      // console.log(this.almacenes);
    },

    // ------------------------------------------------------------------------------
    async getProyectos(){
      this.proyectos = (await axios.get(`${this.getURLAPI}/Show/allProyect`)).data;
      // console.log(this.almacenes);
    },
    
    // ------------------------------------------------------------------------------
    getTexto(item){
      return `${item.FOLIO} | ${item.NOMBRE}`
    },

    // ------------------------------------------------------------------------------
    guardarCambios(){
      if (this.fechaSalida != '' && this.almacenSalida != null && this.proyectoSeleccionado !== null) 
      {  
        let datosForm = new FormData();
        datosForm.append("MAQUINADO_ID",        this.maquinado_id);
        datosForm.append("FECHA_SALIDA",        this.fechaSalida);
        datosForm.append("ALMACEN_SALIDA",      this.almacenSalida);
        datosForm.append("PROYECTO_ID",         this.proyectoSeleccionado);
        datosForm.append("USUARIO_MODIFICADOR", this.getUsuario);
        datosForm.append("ARTICULOS",           JSON.stringify(this.articulos));

        if(this.almacenEntrada != null){
          datosForm.append("ALMACEN_ENTRADA",   this.almacenEntrada);
        }
        if(this.fechaEntrada != null){
          datosForm.append("FECHA_ENTRADA",     this.fechaEntrada);
        }

        for (const val of datosForm.values()) {
          console.log(val);
        }

        axios.post(`${this.getURLAPI}/Maquinado/editarMaquinado`,datosForm)
        .then( ({data}) => {
          this.$root.vtoast.show(
          { message: data.MSG, color:data.STATUS=="OK" ? 'success darken-1' : "red darken-1", 
            timer:10000,       icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
          )
          if(data.STATUS == 'OK'){
            this.getDetalle();
          }

        })
        .catch();

      }
      else{
        this.$root.vtoast.show({
          message: "Verifica los datos",
          color: "black",
          timer: 10000,
          icon: "mdi-alert-circle-outline",
        });
      }
    },

    // ------------------------------------------------------------------------------
    terminarMaquinado(){
      // console.log(this.almacenEntrada);
      let confirmar = confirm(`¿Terminar maquinado ${this.mostrarFolio}?`);

      if (confirmar) {
        if (this.fechaEntrada != '') {
          let datosForm = new FormData();
          datosForm.append("MAQUINADO_ID", this.maquinado_id);
          datosForm.append("USUARIO_MODIFICADOR", this.getUsuario);
          datosForm.append("FOLIO", this.infoMaquinado.FOLIO);
          datosForm.append("FECHA_ENTRADA", this.fechaEntrada);
  
          if(this.almacenEntrada != 0){
            datosForm.append("ALMACEN_ENTRADA", this.almacenEntrada);
          }
          
  
          axios.post(`${this.getURLAPI}/Maquinado/terminarMaquinado`,datosForm)
          .then( ({data}) => {
            this.$root.vtoast.show(
              { 
                message: data.MSG, 
                color:data.STATUS=="OK" ? 'success darken-2' : "red darken-1", 
                timer:10000,
                icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' 
              } 
            )
            if(data.STATUS == 'ERROR_ALMACEN'){
              this.reglas = [ ()=> data.MSG ];
              // console.log(this.reglas);
            }else if(data.STATUS == 'OK') this.$router.push('/maquinado')
          })
          
        } else {
          this.reglasFecha = [() => "Selecciona la fecha de entrada del producto."]
        }
      }
    },

  },

  mounted() {
    window.scrollTo(0,0);
  },
  // ------------------------------------------------------------------------------
  created() {
    this.minFecha = this.getFechaActual.split(" ");
    document.title = "Editar Maquinado | Bombas y Suministros del Norte";
    this.maquinado_id = this.$route.params['id'];
    this.getDetalle();
    this.getAlmacenes();
    this.getProyectos();
  },
};
</script>

<style></style>
